import * as React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

export default function RadioButtonsGroup({
  options,
  title,
  direction = "row",
  onChange,
  selectedvalue,
  disabled = false,
  ...props
}) {
  let flexDirection = "flex-row";
  if (direction == "column") flexDirection = "flex-column";

  const handleChange = (e) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  return (
    <FormControl {...props} disabled={disabled}>
      {title && (
        <FormLabel id="demo-radio-buttons-group-label">{title}</FormLabel>
      )}
      <RadioGroup
        value={selectedvalue != null ? selectedvalue : (options && options.length > 0 ? options[0].value : "")}
        name="radio-buttons-group"
        className={`d-flex ${flexDirection}`}
        onChange={handleChange}
      >
        {options.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            control={<Radio />}
            label={option.label}
            disabled={disabled}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
}
